import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { NotificationManager } from "../../../../../../../components/Notifications";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  deleteLocation: null,
  deleteLocations: []
};

const route = "modules/manage/modals/deleteManageLocations/redux/slice";

export const manageDeleteManageLocations = createAsyncThunk(
  "manage/deleteManageLocation/deleteManageLocations",
  async ({ ids, moveChildsToLocationId = 0 }, { rejectWithValue }) => {
    try {
      const query = `
            mutation deleteLocations ($ids: [Int]!, $moveChildsToLocationId: Int!) {
                deleted: deleteLocations (ids: $ids,  moveChildsToLocationId: $moveChildsToLocationId)
            }
        `;

      const response = await clientMutation(
        query,
        {
          ids,
          moveChildsToLocationId
        },
        endpoints.GRAPHQL_GENERAL_V2
      );

      if (!response?.deleted) {
        throw "Error while deleting locations";
      }
      return response?.deleted;
    } catch (exc) {
      NotificationManager.error(
        "Error",
        `Error Deleting Manage Locations`,
        3000,
        null,
        null,
        "error"
      );
      ExceptionManager(exc, route, "deleteLocations");
      rejectWithValue(exc);
    }
  }
);

const manageDeleteManageLocationRedux = createSlice({
  name: "manage/deleteManageLocation",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
    },
    openModalDeleteManageLocation(state, action) {
      state.open = true;
      state.deleteLocation = action?.payload?.deleteLocation;
      state.deleteLocations = action?.payload?.deleteLocations;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageDeleteManageLocations
    builder.addCase(manageDeleteManageLocations.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageDeleteManageLocations.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(manageDeleteManageLocations.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageDeleteManageLocationRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteManageLocation } = actions;

// Export the reducer, either as a default or named export
export default reducer;
